import { useTranslation } from 'react-i18next'

import { LeadVariant } from 'modules/lead/types'
import HTML from 'common/components/html'

export const LABEL_PATH: { [variant in LeadVariant]: string } = {
  [LeadVariant.SUCCESSFUL_SUBSCRIPTION]: 'successful_subscription',
  [LeadVariant.LIVE_FULL]: 'live_full',
  [LeadVariant.LIVE_FULL_WITH_PLAYBACK]: 'live_full_with_playback'
}

export interface Props {
  variant: LeadVariant,
  maxParticipants?: number
}

const LeadMessage = ({ variant, maxParticipants = 0 }: Props) => {
  const { t } = useTranslation()

  const path = LABEL_PATH[variant]

  return (
    <div className="lead-message" data-test={`variant-${variant}`}>
      <div className="content" data-test={variant}>
        <h1 className="title">{t(`lead_message.${path}.title`)}</h1>
        <HTML className="description" as="p">
          {t(
            `lead_message.${path}.description`,
            variant === LeadVariant.SUCCESSFUL_SUBSCRIPTION
              ? { count: maxParticipants }
              : {}
          )}
        </HTML>
      </div>
    </div>
  )
}

export default LeadMessage
